api = require('./0_def.coffee')

api.factory 'api/Resource#factory', [
  'ksc.RestList',
  (RestList) ->
    ->
      new RestList
        cache: true
        endpoint:
          url: '/dashboard-calendar-ui/api/Resource'
        record:
# class:      ResourceRecord
# contract:   contract
          idProperty: 'resourceId'
          url: '/dashboard-calendar-ui/api/Resource/<id>'
]


api.service 'api/Resource', [
  'api/Resource#factory',
  (resourcesFactory) ->
    service = resourcesFactory()

    # entire response can be cached, no partial loads. Load right away.
    service.restLoad { deleted: false }

    service
]
